//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
export default {
  props: {
    siteWarnList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  dadata: function dadata() {
    return {
      DataSum: {}
    };
  },
  mounted: function mounted() {// this.getDataSum()
  },
  methods: {}
};